<template>
    <error heading="404 Unprepared" showNavHome>
        <template v-slot:image>
            <img
                src="@/assets/images/pages/404.png"
                alt="error-graphic"
                class="mx-auto mb-4 max-w-full"
            />
        </template>
        Sometimes a worthy adventurer such as yourself comes along and goes somewhere we don't
        expect. If I; the elusive developer, had more resources at my disposal, I'm sure we could
        find a way to predict these sorts of tangential desires.<br /><br />
        Unfortunately, until we get funding, you'll have to deal with this terribly dull lack of
        content.
    </error>
</template>

<script>
import Error from './Error'

export default {
    components: {
        Error
    }
}
</script>
